import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Caja } from 'app/models/caja.models';
import { CashBoxSession } from 'app/models/cashBoxSession.models';

@Injectable({
  providedIn: 'root'
})
export class GeneralesService {

  bancos: Observable<any>;
  headers: HttpHeaders;

  constructor(private http: HttpClient) { }

  calcularPrecioVenta(preciounitario: number, utilidad: number, totalimpuestos: number): number {
    /*
      Para el calculo del precio de venta se utiliza la formula
      P = Costo / (1-% margen sobre ventas)
    */
    const preciov = (preciounitario) / (1 - (utilidad / 100));
    const aux = Number.parseFloat((preciov + totalimpuestos).toFixed(2));
    return aux;
  }

  calcularCostoUnitario(precioventa: number, utilidad: number): number {
    const aux = Number.parseFloat((precioventa * (1 - (utilidad / 100))).toFixed(2));
    return aux;
  }

  // x = 153.84   = 100 * (1 - 0.35)

  getOperacionCajas(): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'operacioncajas', { headers: this.headers });
  }

  getResumen(): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'resumen', { headers: this.headers });
  }

  getAperturaCajas(): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'caja/ingresos', { headers: this.headers });
  }

  getOperacionCajasVentas(): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'operacioncaja/ventas/all', { headers: this.headers });
  }

  getIngresosDineroEnCaja(caja): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'cajas/ingresos/' + caja.id, { headers: this.headers });
  }

  obtenerValoresAcumuladosHistoricos() {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'valoresacumulados/ingresos', { headers: this.headers });
  }

  getVentasByApellido(apellido: string) {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'operacioncaja/ventas/nombre/' + apellido, { headers: this.headers });
  }

  eliminarVenta(opercaja): Observable<any> {
    this.getOptions();
    return this.http.delete(environment.apiUrl + 'operacioncaja/' + opercaja, { headers: this.headers });
  }

  eliminarIngreso(opercaja): Observable<any> {
    this.getOptions();
    return this.http.delete(environment.apiUrl + 'operacioncaja/ingreso/' + opercaja, { headers: this.headers });
  }

  getCajaAbierta(): Observable<any> {
    this.getOptions();
    // obtenemos uid del usuario logueado
    const uid = sessionStorage.getItem('uid');
    return this.http.get(environment.apiUrl + 'cash-sessions/is-open/' + uid, { headers: this.headers });
  }

  getSesionCajaById(sesionId): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'cash-sessions/' + sesionId, { headers: this.headers });
  }

  getSumaMovientosByCajaSesion(idSesion): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'cash-sessions/balance/' + idSesion, { headers: this.headers });
  }

  getArrayVentasXDia(): Observable<any> {
    this.getOptions();
    return this.http.get(environment.apiUrl + 'cajas/movimientos/ventaxdia', { headers: this.headers });
  }

  guardarCaja(caja: Caja): Observable<any> {
    this.getOptions();
    return this.http.post(environment.apiUrl + 'cash-boxes', caja, { headers: this.headers });
  }

  addIngresoDineroACaja(caja) {
    this.getOptions();
    return this.http.post(environment.apiUrl + 'operacioncaja/ingresodinero', caja, { headers: this.headers });
  }

  actualizarIngresoCaja(caja): Observable<any> {
    this.getOptions();
    return this.http.patch(environment.apiUrl + 'operacioncaja/' + caja.id, caja, { headers: this.headers });
  }

  cerrarCaja(caja: CashBoxSession): Observable<any> {
    this.getOptions();
    return this.http.patch(environment.apiUrl + 'cash-sessions/close/' + caja.id, {
      description: `Cierre de caja`,
    }, { headers: this.headers });
  }

  private getOptions(): any {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token')
    });
  }

}
